import React from "react";
import ProductCard from "./ProductCard";

function ProductGrid({ products, showAddToCart = false }) {
  if (!products.length) return null;

  return (
    <div className="caf-product-grid">
      {products.map((product) => (
        <ProductCard key={product.id} product={product} showAddToCart={showAddToCart} />
      ))}
    </div>
  );
}

export default ProductGrid;
